import * as utility from '../misc/utility';
import { Person } from '../objects/Person';
import { ResourceEndpoint } from './ResourceEndpoint';

export class PersonEndpoint extends ResourceEndpoint {
    constructor(url, api) {
        super(url, api, Person);
    }

    archive(person, deleteContactInfo, unpublishPublik, politikerExpireDate, deleteFiles) {
        if (!(person instanceof Person)) throw "Invalid parameter, expected person";

        var dst = this.url + '/' + encodeURIComponent(person.Id) + '/archive';

        return this._api.postResponse(dst, {
            Id: person.Id,
            RowVersion: person.RowVersion,
            DeleteContactInformation: deleteContactInfo,
            DeleteFiles: deleteFiles,
            UnpublishPublik: unpublishPublik,
            PolitikerExpireDate: politikerExpireDate,
        }).then(x => x.warnings || {});
    }

    archiveMultiple(persons, deleteContactInfo, unpublishPublik, politikerExpireDate, deleteFiles) {
        var dst = this.url + '/archive';
        var items = persons.map(person => ({
            Id: person.Id,
            RowVersion: person.RowVersion
        }));
        var cmd = {
            Items: items,
            DeleteContactInformation: deleteContactInfo,
            DeleteFiles: deleteFiles,
            UnpublishPublik: unpublishPublik,
            PolitikerExpireDate: politikerExpireDate,
        };
        return this._api.postResponse(dst, cmd).then(rsp => rsp.getResult());
    }

    purge(id) {
        if (!utility.isGuid(id))
            throw "Invalid parameter, expected GUID";

        var dst = this.url + '/' + encodeURIComponent(id) + '/purge';

        return this._api.postVoid(dst, {});
    }
}
